import { supabase } from './supabaseClient';
export interface ReportStatus { published: boolean; revision: number; publishedAt: string | null; }
export interface WrapUpReport {
 title: string; event_date?: string; event_location?: string; gallery_url?: string;
 gallery_password?: string; analytics_url?: string; kpi_data?: Record<string, unknown> | string;
}
async function rpc<T>(name: string, args: Record<string, unknown>): Promise<T> {
 const {data,error} = await supabase.rpc(name,args);
 if(error) throw new Error('Report action was not confirmed. Reload and try again.');
 return data as T;
}
export const reportStatus = (id:string) => rpc<ReportStatus>('admin_wrap_up_status',{p_quote_id:id});
export const previewReport = (id:string) => rpc<WrapUpReport>('admin_wrap_up_preview',{p_quote_id:id});
export const publishReport = (id:string,revision:number) => rpc<ReportStatus>('admin_wrap_up_publish',{p_quote_id:id,p_expected_revision:revision});
export const unpublishReport = (id:string,revision:number) => rpc<ReportStatus>('admin_wrap_up_unpublish',{p_quote_id:id,p_expected_revision:revision});
export const reportToken = () => new URLSearchParams(window.location.hash.split('?')[1] || '').get('report');
export const viewReport = (id:string) => rpc<WrapUpReport>('client_wrap_up_view',{p_quote_id:id,p_report_token:reportToken()});
export function safeReportUrl(value?:string): string | undefined {
 try {const url=new URL(value || ''); return ['https:','http:'].includes(url.protocol) && !url.username && !url.password ? url.href : undefined;} catch {return undefined;}
}
const hex=(bytes:Uint8Array)=>Array.from(bytes,v=>v.toString(16).padStart(2,'0')).join('');
export async function createReportLink(id:string,revision:number) {
 const token=hex(crypto.getRandomValues(new Uint8Array(32)));
 const hash=hex(new Uint8Array(await crypto.subtle.digest('SHA-256',new TextEncoder().encode(token))));
 await rpc('admin_wrap_up_link',{p_quote_id:id,p_token_hash:hash,p_expected_revision:revision});
 return `${window.location.origin}/#/wrap-up/${encodeURIComponent(id)}?report=${token}`;
}
